export const isValidLink = (link: string) => (/^http[s]?:\/\//.test(link));
